module.exports = __webpack_public_path__ + "img/paloma.8ca581c6.jpg";